export default "__VITE_ASSET__Btu1xT90__"